import { createContext } from 'react';
import type { AuthenticationTokens } from '@/api/auth/authApi.types';
import type { Membership } from '@/api/context/currentContextApi.types';
import type { PlatformUser } from '@/api/users/usersApi.types';

export type AuthenticationStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface WorkspaceSwitchTarget {
  scopeCode: string;
  tenantId: string | null;
}

export interface AuthenticationContextValue {
  status: AuthenticationStatus;
  currentUser: PlatformUser | null;
  platformPermissions: string[];
  tenantPermissions: string[];
  memberships: Membership[];
  enabledModules: string[];
  activeWorkspace: Membership | null;
  activeMembership: Membership | null;
  activeScopeCode: string | null;
  activeTenantId: string | null;
  isElevatedWorkspaceAccess: boolean;
  hasSessionExpiredNotice: boolean;
  acknowledgeSessionExpiredNotice: () => void;
  logInWithCredentials: (email: string, password: string) => Promise<void>;
  completeSessionWithTokens: (tokens: AuthenticationTokens) => Promise<void>;
  switchWorkspace: (target: WorkspaceSwitchTarget) => Promise<void>;
  refreshCurrentUser: () => Promise<void>;
  logOut: () => Promise<void>;
}

export const AuthenticationContext = createContext<AuthenticationContextValue | null>(null);
